import { render, staticRenderFns } from "./principalPage.vue?vue&type=template&id=9deb6284&scoped=true&"
import script from "./principalPage.vue?vue&type=script&lang=js&"
export * from "./principalPage.vue?vue&type=script&lang=js&"
import style0 from "./principalPage.vue?vue&type=style&index=0&id=9deb6284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9deb6284",
  null
  
)

export default component.exports